import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { getNewOrderCount } from "../../../actions/ecommerce/onlineOrderAction";
import { Row, Col, Skeleton, Card } from "antd";

const NewOrderCount = ({ getNewOrderCount, Auth, loading, setloading, reload }) => {
    const [count, setCount] = useState(0);

    useEffect(() => {
        getNewOrderCount().then((result) => {
            if (result && result.success) {
                setCount(result.count || 0);
            }
        });
    }, [reload]);

    const Rendercontent = () => {
        if (loading && count === 0) {
            return (
                <>
                    <Skeleton active />
                </>
            );
        } else {
            return (
                <>
                    <Row>
                        <Col
                            span={24}
                            style={{ padding: "0.5rem", border: "1px solid whitesmoke" }}
                        >
                            <Row>
                                <Col span={24}>
                                    <Card
                                        title="New Ecommerce Orders"
                                        className="summary_card transactions stock"
                                        bordered={true}
                                    >
                                        <Row>
                                            <Col span={20} >
                                                <p>New Orders</p>
                                            </Col>
                                            <Col span={4} style={{ textAlign: "right", fontSize: "18px", fontWeight: "bold", color: "red" }}>
                                                {count}
                                            </Col>
                                        </Row>
                                    </Card>
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                </>
            );
        }
    };

    return (
        <>
            <div>{Rendercontent()}</div>
        </>
    );
};

const mapStateToProps = (state) => {
    return {
        Auth: state.auth,
    };
};

export default connect(mapStateToProps, {
    getNewOrderCount,
})(NewOrderCount);
